<template>
    <div>
        <ots-refer v-bind='$attrs' v-on='$listeners'></ots-refer>
        <div class="mainCon">
            <ots-table-new v-bind='$attrs' v-on='$listeners'></ots-table-new>
            <ots-pagination v-bind='$attrs' v-on='$listeners'></ots-pagination>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'OtsTableGroupNew',
  }
</script>
<style lang="less">
    .mainCon {
        margin-top: 16px;
        padding: 24px;
        background: #fff;
        border-radius: 8px;
    }
</style>
